import DropdownButton from "@/components/DropdownButton";
import useProfile from "@/hooks/useProfile";
import { CompanyUser } from "@/schema/CompanyUser";
import useMemberDialog from "@/src/app/(auth)/profile/_hooks/useMemberDialog";
import { useTranslation } from "react-i18next";

interface MemberMenuProps {
  member: CompanyUser;
}

function MemberMenu({ member }: MemberMenuProps) {
  const { t } = useTranslation();
  const { setDialog } = useMemberDialog();
  const { profile, isRoleZero } = useProfile();
  const isMe = member.email === profile?.email;

  if (isMe || !isRoleZero) {
    return null;
  }

  return (
    <DropdownButton
      width="200px"
      items={[
        {
          key: "edit-profile",
          item: t("edit-profile"),
          onClick: () =>
            setDialog({
              type: "edit",
              member: member,
            }),
        },
        {
          key: "reset-password",
          item: t("reset-password"),
          onClick: () =>
            setDialog({
              type: "reset-password",
              member: member,
            }),
        },
        {
          key: "delete",
          item: <span className="text-red-400">{t("delete")}</span>,
          onClick: () =>
            setDialog({
              type: "delete",
              member: member,
            }),
        },
      ]}
    />
  );
}

export default MemberMenu;
